<template>
  <div v-loading="loading">

    <!--HEADER-->
    <div class="flex justify-between">
      <h1>Monthly Invoices</h1>
    </div>

    <el-table
      ref="table"
      empty-text="No Invoices"
      row-key="id"
      :default-sort = "{prop: 'month', order: 'descending'}"
      style="width: 100%"
      @row-click="handleRowClick"
      row-class-name="table-row"
      :data="tableData">
        
        <el-table-column
          label="Month"
          sortable
          :sort-method="dateSort"
          prop="month">
          <template  slot-scope="scope">
            <span class=" inline-block">{{ scope.row.year }} {{scope.row.month | month}}</span>
          </template>
        </el-table-column>

        <el-table-column
          label="Average Active Staff"
          align="left"
          prop="averageActiveDriverCount">
            <template  slot-scope="scope">
              <div>{{ scope.row.averageActiveDriverCount.toFixed(2) }}</div>
            </template>
        </el-table-column>

        <el-table-column
          label="Invoice Status"
          align="left"
          prop="status">
            <template  slot-scope="scope">
              <div>{{ scope.row.status }}</div>
            </template>
        </el-table-column>

        <el-table-column
          label="Total"
          align="right"
          prop="total">
            <template  slot-scope="scope">
              <div>{{ generateTotal(scope.row) | currencyUS }}</div>
            </template>
        </el-table-column>
    </el-table>

    <el-dialog   
      class="invoice-modal"
      :visible.sync="htmlPreviewOpen"
      width="65%"
      :close-on-click-modal="false"
      >
      <span slot="title" class="float-right mr-8">
        <el-button size="small" @click="downloadInvoice" type="primary" :loading="pdfGenerating">Download</el-button>
      </span>
      <div v-html="invoiceTableHtml"></div>
    </el-dialog>

  
  </div>

</template>

<script>
import { invoicesByGroup, getInvoice, getTenant, invoicesByGroupAndYearAndMonth} from './queries'
import generateTemplate from '@/scripts/invoiceTemplate.js';
import invoicePdfService from '@/services/invoicePdfService.js';
import logo from "@/assets/images/logo-no-stroke.png";
import moment from 'moment-timezone';
import { API } from 'aws-amplify';
import { PARENT_ACCOUNT } from '@/views/System/Tenants/constants';

  export default {
    name: 'InvoiceIndex',
    props: [],
    data() {
      return {
        loading: false,
        tableData: [],
        htmlPreviewOpen: false,
        invoiceTableHtml: '',
        tenant: {},
        sufixFileName: null,
        urlLogo: null,
        pdfGenerating: false,
      }
    },

    created() {
      this.toDataURL(logo)
      .then(dataUrl => {
        this.urlLogo = dataUrl;
      })
    },

    mounted(){
        this.loadData()
    },

    methods: {
        dateSort(a,b){
            return new Date(a.createdAt) - new Date(b.createdAt);
        },

      getInvoiceLineItemsFromInvoice(invoice) {
        var invoiceLineItems = invoice.data.getInvoice.invoiceLineItems.items
        if (invoiceLineItems.length) {
          invoiceLineItems = invoiceLineItems.map(item => {
            var total = item.standardCostExt +
              item.bundleCostExt +
              item.performanceCostExt +
              item.rosteringCostExt +
              item.staffCostExt +
              item.vehiclesCostExt +
              item.messagingCostExt;
            item.variableTotal = total;
            return item
          })
          // sort line items by date
          invoiceLineItems.sort(function (a, b) {
            return new Date(a.date) - new Date(b.date);
          })
        }
        return invoiceLineItems;
      },

      async getTenantChildInvoiceLineItems(row) {
        return new Promise(async (resolve, reject) => {
          try {
            const childTenantInvoiceLinesItems = []

            //Get all child tenants
            const body = {
              parentAccountId: this.tenant.id,
              sort: {
                direction: "ASC",
                field: "companyName"
              }
            }
            const childTenants = await API.post('rds', '/query/TenantChildren', { body })

            //Get invoices against all child tenants
            for (const childTenant of childTenants?.data || []) {
              var input = {
                group: childTenant.group,
                yearMonth:{
                  eq: {
                    month: row.month,
                    year: row.year
                  }
                }
              }
              const childInvoices = await this.gLoadListAll(invoicesByGroupAndYearAndMonth, input, 'invoicesByGroupAndYearAndMonth')
              if (childInvoices?.length > 0) {
                //Get invoice line items
                var input = {
                  id: childInvoices[0].id
                }
                var invoice = await this.api(getInvoice, input)
                var invoiceLineItems = this.getInvoiceLineItemsFromInvoice(invoice)
                invoice = invoice.data.getInvoice
                
                //Push current child, invoice and its lines items into childTenantInvoiceLinesItems array 
                childTenantInvoiceLinesItems.push({
                  invoice, lineItems: invoiceLineItems, customer: childTenant
                })
              }
            }
            resolve(childTenantInvoiceLinesItems)
          }

          catch (err) {
            reject(err)
          }
        })
      },

        async handleRowClick(row, column, event){
            // load invoice line items
            this.loading = true
            try{
              let tenentChildInvoiceLineItems = []
              if (this.tenant.accountType == PARENT_ACCOUNT) {
                tenentChildInvoiceLineItems = await this.getTenantChildInvoiceLineItems(row)
              } 

                var input = {
                    id: row.id
                }
                var invoice = await this.api(getInvoice, input)
                var invoiceLineItems = this.getInvoiceLineItemsFromInvoice(invoice)
                this.sufixFileName = `${Number(invoice.data.getInvoice.month) + 1} - ${invoice.data.getInvoice.year}`;
                invoice = invoice.data.getInvoice
                if(invoiceLineItems.length){
                    const customer = this.tenant
                    customer.children = tenentChildInvoiceLineItems

                    // generate html
                    let html = generateTemplate(invoice, invoiceLineItems, customer)
                    html = html.replace(`<img style="height: 90px;" src='https://irp.cdn-website.com/dda4e527/dms3rep/multi/HeraLogoVertical.png'>`, `<img style="height: 90px;" src='${this.urlLogo}'>`);
                    this.invoiceTableHtml = html
                    this.htmlPreviewOpen = true
                }
                this.loading = false

            }catch(e){
                console.error(e)
                this.loading = false
                this.displayUserError(e)
            }
            // open card window with html invoice
        },

        generateTotal(invoice){
          // determine if tenant still has an active trial
          const d = this.getTenantTime(this.tenant.timeZone,-24)
          let todayMidnightUnixTime = new Date(d.dt).setHours(0,0,0,0)
          let trialExpMidnightUnixTime = new Date(this.tenant.trialExpDate).setHours(0,0,0,0)
          let isTrialExpired =  trialExpMidnightUnixTime < todayMidnightUnixTime
          const isInTrial = !isTrialExpired || this.tenant.accountPremiumStatus.includes('trial');
          var invoiceTotal = (0).toFixed(2);
          if(!isInTrial){
            let tenantFlatMonthlyBillingAmount = invoice?.flatMonthlyBillingAmount || 0
            var invoiceSubTotal = invoice.variableTotal + tenantFlatMonthlyBillingAmount
            var taxRate = 0
            var fixedDiscount = invoice.discountFixed ? invoice.discountFixed : 0
            var percentDiscount = invoice.discountPercent ? invoice.discountPercent / 100 * (invoiceSubTotal - fixedDiscount) : 0
            var invoiceTotalWOTax = invoiceSubTotal - fixedDiscount - percentDiscount
            invoiceTotal = (invoiceTotalWOTax + invoiceTotalWOTax * taxRate).toFixed(2)
          }
          
          return invoiceTotal
        },

        async loadData(){
            this.loading = true
            try{
                input = {
                    id: this.$store.state.userInfo.tenant.id
                }
                var tenantResponse = await this.api(getTenant, input)
                var tenant = tenantResponse.data.getTenant
                const parentAccount = tenant?.parentAccount
                if(parentAccount){
                  const parentAccountDiscountSettings = {
                    accountPremiumStatus:parentAccount.accountPremiumStatus,
                    discountFixed:parentAccount.discountFixed,
                    discountFixedLabel:parentAccount.discountFixedLabel,
                    discountPercent:parentAccount.discountPercent,
                    discountPercentLabel:parentAccount.discountPercentLabel, 

                    //Change Bill To to Parent account Bill To information
                    addressCity:parentAccount.addressCity,
                    addressLine1:parentAccount.addressLine1,
                    addressLine2:parentAccount.addressLine2,
                    addressState:parentAccount.addressState,
                    addressZip: parentAccount.addressZip,
                    parentCompanyName: parentAccount.companyName,
                    shortCode: parentAccount.shortCode,
                    stripeBillingEmail:parentAccount.stripeBillingEmail
                  }
                  //Override child tenant discounts and settings with Parent Tenant discount and settings
                  tenant = {...tenant,...parentAccountDiscountSettings}
                }
                this.tenant = tenant
                var input = {
                    group: this.$store.state.userInfo.tenant.group
                }
                this.tableData = await this.gLoadListAll(invoicesByGroup, input, 'invoicesByGroup')

                this.loading = false

            }catch(e){
                console.error(e)
                this.loading = false
                this.displayUserError(e)
            }
        },

        async downloadInvoice() {
          this.pdfGenerating = true;

          try {
            const pdf = await invoicePdfService.generatePdf(this.invoiceTableHtml);
            pdf.save(`Hera Invoice - ${this.sufixFileName}.pdf`);
          } catch (error) {
            console.error('PDF generation error:', error);
            this.$message.error('Failed to generate PDF');
          } finally {
            this.pdfGenerating = false;
          }
        },

        toDataURL (url){ 
          return fetch(url)
            .then(response => response.blob())
            .then(blob => new Promise((resolve, reject) => {
              const reader = new FileReader()
              reader.onloadend = () => resolve(reader.result)
              reader.onerror = reject
              reader.readAsDataURL(blob)
            }))
        },
        getTenantTime(timeZone, offsetHours=0){
          if (!!moment.tz.zone(timeZone)){
            const utc = offsetHours >= 0 ? moment.utc().add(Math.abs(offsetHours), 'hours'):moment.utc().subtract(Math.abs(offsetHours), 'hours');
            const isoUtcDate = utc.format("YYYY-MM-DDTHH:mm:ssZZ");
            const dt = utc.clone().tz(timeZone);
            const isoDate = dt.format("YYYY-MM-DDTHH:mm:ssZZ");
            const year = dt.year()
            const month = dt.month()
            const day = dt.date()
            //Month is 0 index but this function is 1 index, so adding 1 to month
            const numOfDays = new Date(year, month + 1, 0).getDate();
            return {dt:dt, day:day, month:month, year:year, numOfDays: numOfDays, isoDate:isoDate, utcDt: utc, isoUtcDate: isoUtcDate};
          }
          else{
            console.log("Tenant has invalid timezone value");
            return null;
          }
        }
    },
  }
</script>
<style>
.invoice-modal .el-dialog{
  max-width: 92%;
  overflow: auto;
}
.invoice-modal .el-dialog .el-dialog__body{
  width: 100%;
  overflow: auto;
}
.invoice-modal .el-dialog .el-dialog__body > div{
  min-width: 850px;
}
</style>